import dayjs from 'dayjs';
import React, { createContext, ReactNode, useContext, useState } from 'react';

interface AccountingPeriodContextValue {
  startDate: string | null;
  endDate: string | null;
  setPeriod: (start: string | null, end: string | null) => void;
}

const getDefaultPeriod = () => {
  const now = dayjs();
  return {
    startDate: now.startOf('month').format('YYYY-MM-DD'),
    endDate: now.endOf('month').format('YYYY-MM-DD'),
  };
};

export const AccountingPeriodContext =
  createContext<AccountingPeriodContextValue | null>(null);

interface AccountingPeriodProviderProps {
  children: ReactNode;
}

export const AccountingPeriodProvider: React.FC<
  AccountingPeriodProviderProps
> = ({ children }) => {
  const [period, setPeriodState] = useState<{
    startDate: string | null;
    endDate: string | null;
  }>(getDefaultPeriod);

  const setPeriod = (start: string | null, end: string | null) => {
    setPeriodState({ startDate: start, endDate: end });
  };

  return (
    <AccountingPeriodContext.Provider
      value={{
        startDate: period.startDate,
        endDate: period.endDate,
        setPeriod,
      }}
    >
      {children}
    </AccountingPeriodContext.Provider>
  );
};

export const useAccountingPeriod = (): AccountingPeriodContextValue => {
  const context = useContext(AccountingPeriodContext);

  if (!context) {
    throw new Error(
      'useAccountingPeriod must be used within an AccountingPeriodProvider',
    );
  }

  return context;
};
